import styled from"@emotion/styled";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import{Button,Card}from"@wp/src/components/common";import{Body1W500Neutral500,H5W500Neutral800}from"@wp/src/components/common/atoms";import*as React from"react";import GpHeaderLogo from"@wp/src/components/common/layoutManagers/public/molecules/GpHeaderLogo";export const LandingContainer=styled(FlexLayout)`
  text-align: center;
  width: 100%;
  min-height: inherit;
  padding: 40px;
`;export const LandingStartButton=styled(Button)`
  width: 300px;
`;export const QuestionIconContainer=styled(FlexLayout)`
  width: 56px;
  height: 56px;
  background: ${props=>props.theme.colors.blue200};
  border-radius: 56px;
`;export const QuestionContainer=styled(H5W500Neutral800)`
  text-align: center;
  margin: auto 12px auto 12px;
  max-width: 720px;
`;export const OptionLabelContainer=styled(Body1W500Neutral500)`
  text-align: center;
  max-width: 720px;
  margin-top: 20px;
`;export const RiskProfileQuestionContainer=styled(FlexLayout)`
  text-align: center;
  min-height: inherit;
  overflow-y: auto;
  width: 100%;
  background: ${props=>props.theme.colors.appBackgroundColor};
`;export const RiskQuestionnaireContainer=styled.div`
  min-height: calc(var(--full-vh, 100vh));
  overflow-y: auto;
  background: ${props=>props.theme.colors.appBackgroundColor};
`;export const StyledRadioGroup=styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
`;export const ChoiceCard=styled.div`
  border: 1px solid transparent;
  .ant-radio-wrapper-checked & {
    border: 1px solid ${props=>props.theme.colors.borderBlue};
  }
  border-radius: var(--card-border-radius, 8px);
  background: ${props=>props.theme.colors.white};
  display: flex;
  align-items: center;
  align-content: center;
  ${props=>mediaQuery({flexDirection:props.flexDirection?props.flexDirection:["row","row","column"],padding:props.size==="small"?["10px 10px","10px 0px","15px 0px","15px 0px","20px 0px","20px 0px"]:["20px 20px","20px 0px","30px 0px","30px 0px","40px 0px","40px 0px"],justifyContent:["flex-start","center"]})}
  min-width: 250px;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  color: ${props=>props.theme.colors.neutral900};
  margin-bottom: 20px;
`;export const ChoiceIconContainer=styled(FlexLayout)`
  background: ${props=>props.theme.colors.neutral100};
  border-radius: 50%;
  ${props=>mediaQuery({width:props.choiceCardFlexDirection?["32px"]:["32px","32px","80px"],height:props.choiceCardFlexDirection?["32px"]:["32px","32px","80px"],marginBottom:props.choiceCardFlexDirection?["0px"]:["0px","0px","8px"],marginRight:props.choiceCardFlexDirection?["8px"]:["8px","8px","0px"]})}
`;export const RiskHeaderContainer=styled(FlexLayout)`
  background: ${props=>props.theme.colors.white};
  padding: 0 20px;
  height: 64px;
  width: 100vw;
  box-shadow: 0 4px 8px ${props=>props.theme.colors.boxShadow};
`;export const RiskFooterContainer=styled(FlexLayout)`
  background: ${props=>props.theme.colors.white};
  height: 80px;
  width: 100vw;
  padding: 20px;
  box-shadow: 0 4px 8px ${props=>props.theme.colors.boxShadow};
  ${mediaQuery({justifyContent:["space-between","flex-end","flex-end","flex-end","flex-end","flex-end","flex-end"]})}
  .ant-btn {
    ${mediaQuery({flexBasis:["45%","45%","20%","20%","20%","15%"]})}
  }
`;export const RiskPercentageContainer=styled(FlexLayout)`
  border-radius: 50%;
  background-color: ${props=>props.theme.colors.blue50};
  font-weight: 800;
  font-size: 36px;
  line-height: 32px;
  width: 100px;
  height: 100px;
`;export const RiskDescriptionCard=styled(Card)``;export const RiskDescriptionContainer=styled.div`
  display: flex;
  justify-content: center;
  ${mediaQuery({flexDirection:["column","row"]})}
  align-content: center;
  align-items: center;
  column-gap: 20px;
  font-size: 14px;
  font-weight: 700;
  max-width: 700px;
`;export const RiskDescription=styled.div`
  word-break: break-word;
  white-space: initial;
  flex-basis: 65%;
`;export const RiskHeading=styled.div`
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  color: ${props=>props.theme.colors.neutral900};
  margin-bottom: 8px;
`;export const RiskCalculatorContainer=styled(FlexLayout)`
  height: calc(var(--full-vh, 100vh) - 80px);
  padding: 16px;
  flex-wrap: nowrap;
`;export const RiskCalculatorQuestionnaireDescription=styled(Body1W500Neutral500)`
  max-width: 450px;
  text-align: center;
`;export const RiskHeader=()=>{return React.createElement(RiskHeaderContainer,{justifyContent:"flex-start"},React.createElement(GpHeaderLogo,null))};export const RiskQuestionnaireLinkContainer=styled.div`
  padding: 8px 0;
`;